import { render } from "./TaskNotification.vue?vue&type=template&id=7e47259f"
import script from "./TaskNotification.vue?vue&type=script&lang=js"
export * from "./TaskNotification.vue?vue&type=script&lang=js"

import "./TaskNotification.vue?vue&type=style&index=0&id=7e47259f&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__